import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa para usar este kit?',
  a: 'No. Está pensado para principiantes y organizado de forma visual y simple para que puedas empezar desde cero.'
}, {
  q: '¿Qué voy a recibir exactamente?',
  a: 'Vas a recibir un producto digital con una guía inicial, más de 200 moldes para comenzar a diseñar y una guía para aprender a emprender desde casa.'
}, {
  q: '¿Es un producto físico?',
  a: 'No. Es un kit digital, por lo que lo recibís online y podés acceder a él de forma inmediata.'
}, {
  q: '¿Lo puedo usar para vender mis creaciones?',
  a: 'Sí. El kit está pensado también para inspirarte a crear piezas con potencial para regalar o vender.'
}, {
  q: '¿Voy a poder hacerlo si recién empiezo?',
  a: 'Sí. Justamente fue creado para acompañarte paso a paso y ayudarte a empezar con más claridad y confianza.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-24">
      <div className="text-center mb-16" data-id="element-25">
        <h2 className="text-4xl sm:text-5xl text-brand-text mb-6" data-id="element-26">
          Preguntas frecuentes
        </h2>
      </div>

      <div className="space-y-4" data-id="element-27">
        {faqs.map((faq, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.1
      }} className="bg-brand-card rounded-2xl border border-brand-accent/20 overflow-hidden shadow-sm" data-id="element-28">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-brand-alt-bg/10 transition-colors" data-id="element-29">
              <span className="font-serif text-xl text-brand-text pr-8" data-id="element-30">
                {faq.q}
              </span>
              <ChevronDown className={`text-brand-cta shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} size={24} data-id="element-31" />
            </button>

            <AnimatePresence data-id="element-32">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-33">
                  <div className="px-6 pb-6 pt-2 text-brand-text/80 leading-relaxed font-sans border-t border-brand-accent/10" data-id="element-34">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}